import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';

class OrderForm extends Component {
	constructor(props) {
		super(props);
		
		let estat = {...props}
		this.state = {...estat,
					showPhases: true,
					processing: false,
					loading: true,
					excelTxt: 0};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeInt = this.handleChangeInt.bind(this);
		this.handlecheckbox = this.handlecheckbox.bind(this);
		this.handleChangeTranslator = this.handleChangeTranslator.bind(this);
		this.handleMatchChange = this.handleMatchChange.bind(this);
		this.handleFilename = this.handleFilename.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleReinterpretar = this.handleReinterpretar.bind(this);
		this.handlePreprocesar = this.handlePreprocesar.bind(this);
		this.handleReTraduir = this.handleReTraduir.bind(this);
		this.pintaTmxMatch = this.pintaTmxMatch.bind(this);
		this.pintaPhases = this.pintaPhases.bind(this);
		this.orderUsers=this.orderUsers.bind(this);
		this.newWords=this.newWords.bind(this);
		this.handleRate=this.handleRate.bind(this);
		this.handleChangeState=this.handleChangeState.bind(this);
		this.handle_excelTxt=this.handle_excelTxt.bind(this);
	}
	
	componentDidUpdate(prevProps, prevState) {
		if ((typeof prevState.tmxMatch === 'undefined' || prevState.tmxMatch === null) && typeof this.props.tmxMatch !== 'undefined' && Array.isArray(this.props.tmxMatch)) {
			this.setState({ tmxMatch: this.props.tmxMatch })
		}
	}


	handleReinterpretar(){
		this.setState({processing: true});
		this.props.reinterpretar(this.props.order.id, this.state.excelTxt);
	}
	
	handlePreprocesar(){
		this.setState({processing: true});
		this.props.preprocesar(this.props.order.id);
	}
	
	handleReTraduir(){
		this.setState({processing: true});
		this.props.reTraduir(this.props.order.id);
	}
	
	handleRate(){
		this.setState({processing: true});
		this.props.rate(this.props.order.id);
	}
	
	handleChangeTranslator(e){
		e.preventDefault();
		const {name, value} = e.target;
		
		if(parseInt(value,10)!==0){
			//let phaseIndex=-1;
			let phaseIndex=[];
			for (var i = 0; i < this.state.order.phase.length; i++) {
				if(this.state.order.phase[i].type=="TRANSLATION" || this.state.order.phase[i].type=="PROOF_PRINTING"){
					if(this.state.order.phase[i].user!==null){
						//user = this.props.translators[this.state.order.phase[i].user];
						phaseIndex.push(i);
					}
				}
			}
			if(phaseIndex.length>0){
				var newOrder = {...this.state.order}
				for(let i=0; i<phaseIndex.length; i++){
					newOrder.phase[phaseIndex[i]].user = parseInt(value,10);
				}
				this.setState({order: newOrder});
			}
		}
	}
	
	handleChangeState(e){
		e.preventDefault();
		const {name, value} = e.target;
		
		//var newOrder = {...this.state.order}
		//newOrder.state = value;
		this.setState({
				order: {
					...this.state.order,
					state: value
				}
			});
	}
	
	handleChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({
			order: {
				...this.state.order,
				[name]: value
			}
		});
	}
	
	//match[index][parsedName] = value.length>0 ? parseInt(value) : 0;
	handleChangeInt(e) {
		e.preventDefault();
		const {name, value} = e.target;
		let valorNoBuit = value.length>0 ? parseInt(value) : 0;
		this.setState({
			order: {
				...this.state.order,
				[name]: valorNoBuit
			}
		});
	}
	
	handlecheckbox(e){
		const {name, checked} = e.target;
//		console.log(name+","+checked);
		this.setState({
			order: {
				...this.state.order,
				[name]: (checked ? 1:0)
			}
		});
	}
	
	handle_excelTxt(e){
		const {name, checked} = e.target;
		this.setState({ excelTxt: (checked ? 1:0) });
	}
	
	handleMatchChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		let split = name.split("_");
		let index = split[0];
		let parsedName = split[1];
//		this.setState({
//			order: {
//				...this.state.order,
//				tmx_match: {
//					...this.state.order.tmx_match,
//					[name]: value
//				}
//			}
//		});
		let match = [...this.state.tmxMatch];
		match[index][parsedName] = value.length>0 ? parseInt(value) : 0;
		this.setState({
			...this.state,
			tmxMatch: match
		});
	}
	
	handleFilename(e) {
		e.preventDefault();
		const {name, value} = e.target;
		
		let newPhase = this.state.order.phase;
		// cerca index de la última fase
		let maxSequence=0;
		let maxSequenceIndex=0;
		for(let i=0; i<newPhase.length; i++){
			if(newPhase[i].sequence > maxSequence){
				maxSequence = newPhase[i].sequence;
				maxSequenceIndex = i;
			}
		}
		//console.log("handleFilename index[max seq: "+maxSequence+"] = " + maxSequenceIndex);
		// En cas de ser un xliff no hem amagat l'extensió. Ara cal afegir-la
		let extension = newPhase[maxSequenceIndex].document.filename.slice((newPhase[maxSequenceIndex].document.filename.lastIndexOf(".") - 1 >>> 0) + 2);
		newPhase[maxSequenceIndex].document.filename = value + ( (extension == "xlf") ? ".xlf":"");
		//console.log("handleFilename: " + newPhase[maxSequenceIndex].document.filename);
		
		let order = {...this.state.order, phase : newPhase};
		//console.log("handleFilename Order: "+JSON.stringify(order));
		this.setState({order});
	}
	
	handleSubmit(e) {
		e.preventDefault();
		this.props.saveOrderForm(this.state.order, this.state.tmxMatch);
	}
	
	pintaPhases(){
		const rows = [];
		if(this.props.order.phase){
			this.props.order.phase.sort(function(a, b) {return a.sequence-b.sequence}).forEach(
											element => {
															rows.push(
																<TableRow key={element.id}>
																	<TableCell>{element.id}</TableCell>
																	<TableCell>{element.type}</TableCell>
																	<TableCell><a target="_blank" style={{textDecoration: 'none'}} href={process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+element.document.id+"/content?access_token="+this.props.accessToken} title={element.document.filename}>{element.document.filename}</a></TableCell>
																</TableRow>
															);
											}
										);
		}
		return <Table className="lst">
		    <TableHead>
		      <TableRow>
		        <TableCell>Id</TableCell>
				<TableCell>Type</TableCell>
				<TableCell>Document</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
            </TableFooter>
			</Table>
	}
	
	newWords(role){
		let matchWords = 0;
//		console.log(this.state);
		if(this.state.tmxMatch && Array.isArray(this.state.tmxMatch) && this.state.tmxMatch.length>role){
			matchWords = this.state.tmxMatch[role].match100 + this.state.tmxMatch[role].match95 + this.state.tmxMatch[role].match90 + this.state.tmxMatch[role].match85 + this.state.tmxMatch[role].match80 + this.state.tmxMatch[role].match75;
		}
		var repWords;
		var words;
		if(role===0){
			repWords = this.state.order.repetitions;
			words = this.state.order.wordCount;
		}else{
			repWords = this.state.order.repetitionsTrs;
			words = this.state.order.wordCountTrs;
		}
		let nw = words-repWords-matchWords;
		return (nw>0 ? nw : 0)
	}
	
	pintaTmxMatch(){
		var matchArray = [];
		if(typeof this.state.tmxMatch !== 'undefined'){
			//console.log("pintaTmxMatch: Existeix this.state.order.tmx_match");
			//console.log("Array.from(this.state.order.tmx_match):"+Array.from(this.state.order.tmx_match));
//			Array.from(this.state.order.tmx_match).forEach((tmx_match) => {
			for (var i in this.state.tmxMatch) {
				let tmx_match = this.state.tmxMatch[i];
				//console.log("pintaTmxMatch: Un element de l'array");
				let row = <Grid container direction="row" alignItems="center" justify="flex-start" spacing={2} xs={12}>
						<Grid item xs={1}>
							({tmx_match.target.charAt(0)})
						</Grid>
						<Grid item xs={1}>
							<TextField
								id={i+"_match100"}
								label="100%"
								margin="normal"
								name={i+"_match100"}
								defaultValue={tmx_match.match100}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
					
						<Grid item xs={1}>
							<TextField
								id={i+"_match95"}
								label="95%"
								margin="normal"
								name={i+"_match95"}
								defaultValue={tmx_match.match95}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
					
						<Grid item xs={1}>
							<TextField
								id={i+"_match90"}
								label="90%"
								margin="normal"
								name={i+"_match90"}
								defaultValue={tmx_match.match90}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={1}>
							<TextField
								id={i+"_match85"}
								label="85%"
								margin="normal"
								name={i+"_match85"}
								defaultValue={tmx_match.match85}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={1}>
							<TextField
								id={i+"_match80"}
								label="80%"
								margin="normal"
								name={i+"_match80"}
								defaultValue={tmx_match.match80}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
						<Grid item xs={1}>
							<TextField
								id={i+"_match75"}
								label="75%"
								margin="normal"
								name={i+"_match75"}
								defaultValue={tmx_match.match75}
								onChange={this.handleMatchChange}
								InputLabelProps={{
									shrink: true,
								}}
							/>
						</Grid>
					</Grid>
				matchArray.push(row);
			}
//			});
			//console.log("pintaTmxMatch: matchArray.length="+matchArray.length);
			return (matchArray);
		}else{
			//console.log("pintaTmxMatch: NO Existeix this.state.order.tmx_match");
			return (<div> TMXMATCH </div>);
		}
	}
	
	orderUsers(a, b){
		return this.props.translators[a].username.localeCompare(this.props.translators[b].username);
	}
	
	render() {
//		console.log("RENDER OrderForm");
//		console.log(this.props);
//		console.log(this.state.order);
		console.log(this.state.excelTxt);
		var tmxMatch;
		var translatorStats;
		var procesInstance;
		var translatorSelect;
		let phases="";
		
		if(this.state.processing){
			return (<div>PROCESSING...</div>);
		}
		
		var translators = []
		var keys = Object.keys(this.props.translators).sort(this.orderUsers);
		for(let i=0; i<keys.length; i++) {
			translators.push(<option value={this.props.translators[keys[i]].id}>{this.props.translators[keys[i]].username}</option>)
		}
			
		if(this.props.translators !== undefined && this.props.translators !== null){
			var user=null;
			for (var i = 0; i < this.state.order.phase.length; i++) {
				if(this.state.order.phase[i].type=="TRANSLATION" || this.state.order.phase[i].type=="PROOF_PRINTING" || this.state.order.phase[i].type=="RATING"){
					if(this.state.order.phase[i].user!==null){
						user = this.props.translators[this.state.order.phase[i].user];
					}
				}
			}
			
			if(user!== undefined && user !==null){
				translatorSelect=<FormControl>
									<InputLabel>Translator</InputLabel>
									<Select
										native
										value={user.id}
										onChange={this.handleChangeTranslator}
										inputProps={{
											name: 'translator',
											id: 'translator-native-simple',
										}}
										>
										{translators}
									</Select>
								</FormControl>
			}else{
				translators.push(<option value={0}>{'-'}</option>)
				translatorSelect=<FormControl>
										<InputLabel>Translator</InputLabel>
										<Select
											native
											value={0}
											onChange={this.handleChangeTranslator}
											inputProps={{
												name: 'translator',
												id: 'translator-native-simple',
											}}
											>
											{translators}
										</Select>
									</FormControl>
			}
		}
		const states = ['FINISHED','TRANSLATION','PROOF_PRINTING','RATING','FORMAT_QA'];
		const stateOptions = [];
		for(let i=0; i<states.length; i++) {
			stateOptions.push(<option value={states[i]}>{states[i]}</option>);
		}
		const orderStateSelect = <FormControl>
								<InputLabel>State</InputLabel>
								<Select
									native
									value={this.state.order.state}
									onChange={this.handleChangeState}
									inputProps={{
										name: 'state',
										id: 'state-native-simple',
									}}
									>
									{stateOptions}
								</Select>
							</FormControl>

		if(this.state.tmxMatch !== undefined && this.state.tmxMatch !== null ){
//			if(this.state.loading){
//				//console.log('[-- LOADING --]');
//				this.setState({
//					order: this.props.order,
//					tmxMatch: this.props.tmxMatch,
//					//order: {
//					//	...this.state.order,
//					//	tmx_match: {
//					//		...this.props.order.tmx_match
//					//	}
//					//},
//					loading: false
//				},
//				function() {/* console.log("setState completed")*/})
//			}
			tmxMatch=this.pintaTmxMatch();
		}else{
			tmxMatch="LOADING...";
		}
		//if(this.state.order.wordCountTrs){
			translatorStats =
				<Grid container item direction="row" alignItems="center" justify="flex-start" spacing={2} xs={12}>
					<Grid item xs={1}>
					<TextField
						id="wordcount-translator"
						label="Total words (T)"
						name="wordCountTrs"
						margin="normal"
						defaultValue={this.state.order.wordCountTrs}
						onChange={this.handleChangeInt}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					</Grid>
					<Grid item xs={1}>
					<TextField
						id="repetitions-translator"
						label="Repetitions (T)"
						name="repetitionsTrs"
						margin="normal"
						defaultValue={this.state.order.repetitionsTrs}
						onChange={this.handleChangeInt}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					</Grid>
					<Grid item xs={1}>
						<TextField
							disabled
							id="new-words-translator"
							label="New Words (T)"
							name="newWordsTrs"
							margin="normal"
							defaultValue={this.newWords(1)}
							value={this.newWords(1)}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
				</Grid>
		//}
		if(this.state.order.processInstanceId){
			procesInstance = <Grid item xs={12}>
								Activiti Instance: {this.state.order.processInstanceId}
							</Grid>
		}
		if(this.state.showPhases){
			phases = this.pintaPhases();
		}
		
		let uploader = "";
		if(typeof(this.props.customerUser)!=='undefined'){
			uploader = this.props.customerUser.username;
		}
		const reinterpretarBtn = (this.props.order.state=="FINISHED"?"":<Button onClick={this.handleReinterpretar} size="small" variant="outlined" aria-label="Reinterpretar">Reinterpretar</Button>)
		const repreprocesarBtn = (this.props.order.state=="FINISHED"?"":<Button onClick={this.handlePreprocesar} size="small" variant="outlined" aria-label="Preprocesar">Preprocesar</Button>)
		const retraduirBtn = (this.props.order.state=="FINISHED"?<Button onClick={this.handleReTraduir} size="small" variant="outlined" aria-label="Preprocesar">Reactivar traducción</Button>:"")
		const rateBtn = ( (this.props.order.state=="FINISHED")&&(this.props.order.task=="translation")?<Button onClick={this.handleRate} size="small" variant="outlined" aria-label="Rate">Rate translator</Button>:"")
		
		let repreprocesarCheckBox = '';
		if(this.props.order.state!="FINISHED"){
			repreprocesarCheckBox = <FormControlLabel
					control={
						<Checkbox
							name="excelTxt"
							checked={this.state.excelTxt}
							color="primary"
							onChange={this.handle_excelTxt}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>Excel+Txt</Typography>}
					labelPlacement="start"
				/>
		}
		
		return (
			<div className="contentM">
			<form 
				action={this.props.action}
				method={this.props.method}
				onSubmit={this.onSubmit}
			>
			<Grid container direction="column" alignItems="flex-start" justify="flex-start" spacing={2} xs={12}>
				<Grid item xs={12}>
					Code: {this.props.order.code} {this.props.order.task}
				</Grid>
				{procesInstance}
				<Grid item xs={12}>
					Customer user: {uploader}
				</Grid>
				<Grid item xs={12}>
					{orderStateSelect}
				</Grid>
				<Grid item xs={12}>
					{translatorSelect}
				</Grid>
				<Grid item  xs={12}><FormControlLabel
					control={
						<Checkbox
							name="urgent"
							checked={this.state.order.urgent>0}
							color="primary"
							onChange={this.handlecheckbox}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>Urgent</Typography>}
					labelPlacement="start"
				/>
				</Grid>
				<Grid item  xs={12}><FormControlLabel
					control={
						<Checkbox
							name="special"
							checked={this.state.order.special>0}
							color="primary"
							onChange={this.handlecheckbox}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>Specialized</Typography>}
					labelPlacement="start"
				/>
				</Grid>
				<Grid container item direction="row" alignItems="center" justify="flex-start" spacing={2} xs={12}>
					<Grid item xs={1}>
						<TextField
							id="wordcount"
							label="Total words"
							name="wordCount"
							margin="normal"
							defaultValue={this.state.order.wordCount}
							onChange={this.handleChangeInt}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
					<Grid item xs={1}>
						<TextField
							id="repetitions"
							label="Repetitions"
							name="repetitions"
							margin="normal"
							defaultValue={this.state.order.repetitions}
							onChange={this.handleChangeInt}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
					<Grid item xs={1}>
						<TextField
							disabled
							id="new-words"
							label="New Words"
							name="newWords"
							margin="normal"
							value={this.newWords(0)}
							defaultValue={this.newWords(0)}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
				</Grid>
				{translatorStats}
			
				<Grid item xs={12}>
					<div>TMX match:</div>
					{tmxMatch}
				</Grid>
				<Grid item xs={6}>
					<TextField
						id="filename"
						name="filename"
						label="Translated file name"
						/*Busca el nom del document de la Última fase i retalla .xlf del final*/
						defaultValue ={this.props.order.phase.reduce(function(prev, current) {
											return (prev.sequence > current.sequence) ? prev : current
										}).document.filename.replace(/.xlf$/, '')}
						margin="normal"
						onChange={this.handleFilename}
					/>
				</Grid>
				<Grid item xs={4}>
					<TextField
						id="reference"
						name="reference"
						label="Cutomer Reference"
						defaultValue={this.state.order.reference}
						margin="normal"
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item xs={4}>
					<Button onClick={this.handleSubmit.bind(this)} variant="contained" color="primary" aria-label="Save">Save</Button>
				</Grid>
			</Grid>
			</form>
			<Grid container direction="row" alignItems="center" justify="flex-start" spacing={2} xs={12}>
				<Grid item xs={3}>
					<h3>Phases:</h3>
				</Grid>
				<Grid item xs={3}>
					{reinterpretarBtn}
					{repreprocesarCheckBox}
				</Grid>
				<Grid item xs={3}>
					{repreprocesarBtn}
					{rateBtn}
				</Grid>
				<Grid item xs={3}>
					{retraduirBtn}
				</Grid>
			</Grid>
			{phases}
			</div>
		);
	}
}

export default OrderForm;